// Wrap getCurrentPosition in a Promise
export function getCurrentLocation(opts = {}) {
	return new Promise((resolve, reject) => {
		if (!('geolocation' in navigator)) {
			return reject(new Error('Geolocation not supported'));
		}
		const defaults = { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 };
		navigator.geolocation.getCurrentPosition(
			pos => resolve({
				lat: pos.coords.latitude,
				lon: pos.coords.longitude,
				accuracy: pos.coords.accuracy,
				timestamp: new Date(pos.timestamp).toISOString()
			}),
			err => reject(err),
			{ ...defaults, ...opts }
		);
	});
}

// Subscribe to continuous updates; returns an unsubscribe
export function watchLocation(callback, opts = {}) {
	if (!('geolocation' in navigator)) {
		throw new Error('Geolocation not supported');
	}
	const defaults = { enableHighAccuracy: true, maximumAge: 2000, timeout: 20000 };
	const id = navigator.geolocation.watchPosition(
		pos => callback({
			lat: pos.coords.latitude,
			lon: pos.coords.longitude,
			accuracy: pos.coords.accuracy,
			timestamp: pos.timestamp
		}),
		err => console.warn('watchPosition error:', err),
		{ ...defaults, ...opts }
	);
	return () => navigator.geolocation.clearWatch(id);
}

// Permissions API helper (may be null on some browsers)
export async function getGeoPermission() {
	if (!('permissions' in navigator)) return null;
	try {
		const status = await navigator.permissions.query({ name: 'geolocation' });
		return status.state; // 'granted' | 'prompt' | 'denied'
	} catch {
		return null;
	}
}
